module.exports = __webpack_public_path__ + "img/2025-06-11a_4.fd2d7abd.jpg";